import ProductInfoTable from "./productInfoTable";

export default ProductInfoTable;